export interface IUser {
  id: string;
  name: string;
  profileImageUrl?: string;
  email?: string;
}

class User {
  public readonly id: string;
  public readonly name: string;
  public readonly profileImageUrl?: string;
  public readonly email?: string;

  constructor({
    id,
    profileImageUrl,
    name,
    email,
  }: {
    id: string;
    name: string;
    profileImageUrl?: string;
    email?: string;
  }) {
    this.id = id;
    this.profileImageUrl = profileImageUrl;
    this.name = name;
    this.email = email;
  }

  public toJSON = () => ({
    id: this.id,
    profileImageUrl: this.profileImageUrl,
    name: this.name,
    email: this.email,
  });

  public static fromJSON = (json: IUser): User => {
    const { id, profileImageUrl, name, email } = Object.assign({}, json);

    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof name !== 'string') throw new Error('.name must be a string');
    if (typeof profileImageUrl !== 'string' && profileImageUrl !== undefined)
      throw new Error('.profileImageUrl must be a string or undefined');
    if (typeof email !== 'string' && email !== undefined) throw new Error('.email must be a string or undefined');

    return new User({
      id,
      profileImageUrl,
      name,
      email,
    });
  };
}

export default User;
